import { inject, Injectable } from '@angular/core';
import { LeadInsertRequest, LeadInsertResponse } from '../models/lead-insert.interface';
import { RestApiService } from '@pc/services';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LeadInsertService {
  private restApiService = inject(RestApiService);

  public insertLead(body: LeadInsertRequest): Observable<LeadInsertResponse> {
    return this.restApiService.post<LeadInsertResponse>('leadInsert/leadInsert', body, true);
  }
}
